import React, { useState, useEffect, useRef } from "react";

import { API_URL } from "../helpers";

import Alert from "../components/Alert";

export default function Table({ peerGroup }) {
	const [alert, setAlert] = useState({ type: "working", text: "" });
	const [details, setDetails] = useState({});

	const initRef = useRef(false);

	useEffect(() => {
		if (initRef.current) return;
		initRef.current = true;

		init();
	});

	const init = async () => {
		const url = new URL(`${API_URL}/toolsLeaderboardInit`);
		const params = {
			peerGroup,
		};
		url.search = new URLSearchParams(params);

		try {
			const response = await fetch(url, {
				method: "GET",
				cache: "no-store",
			});
			const json = await response.json();
			if (json && json.resp === 1) {
				setDetails({ ...json });
				setAlert({});
			} else {
				setAlert({
					type: json.resp === 2 ? "notice" : "error",
					text: json.text,
				});
			}
		} catch (error) {
			setAlert({
				type: "error",
				text: "An error has occurred.",
			});
		}
	};

	return (
		<>
			{alert.type ? (
				<table className="right-column-table">
					<tbody>
						<tr>
							<td>
								<Alert data={alert} />
							</td>
						</tr>
					</tbody>
				</table>
			) : (
				<table className="right-column-table">
					<thead>
						<tr>
							<th
								colSpan="3"
								className="center"
								style={{
									color: "#007cba",
									paddingTop: "5px",
									fontSize: "17px",
									fontWeight: "bold",
								}}
							>
								{`Peer Group ${details.group}`}
							</th>
						</tr>
						<tr>
							<td
								colSpan="3"
								className="center"
								style={{
									paddingTop: "0",
									fontSize: "16px",
								}}
							>
								{`Operating Budget: ${details.aob}`}
							</td>
						</tr>
						<tr>
							<th className="center">Rank</th>
							<th className="center">Charity Name</th>
							<th className="center">Total</th>
						</tr>
					</thead>
					<tbody>
						{details.top4.map((item) => {
							return (
								<tr key={item.charityId}>
									<td className="center">{item.rank}</td>
									<td className="center">{item.charity}</td>
									<td className="center">{item.total}</td>
								</tr>
							);
						})}
					</tbody>
					<tfoot>
						<tr>
							<td colSpan="3"></td>
						</tr>
					</tfoot>
				</table>
			)}
		</>
	);
}
